
import React from 'react';

// ============================================
// EXPLICIT STATIC IMPORTS FOR ALL COMPONENTS
// The dynamic import pattern was creating empty media files instead of JS bundles.
// Using explicit static imports ensures Webpack correctly bundles each component.
// ============================================

const StaticComponentRegistry = {
    ChapterTitleScreen: React.lazy(() => import('../components/navigation/ChapterTitleScreen')),
    DialogueFeature: React.lazy(() => import('../components/learning/DialogueFeature')),
    DialogueUniversal: React.lazy(() => import('../components/learning/DialogueUniversal')),
    VocabularyFeature: React.lazy(() => import('../components/learning/VocabularyFeature')),
    TranslationMatching: React.lazy(() => import('../components/exercises/TranslationMatching')),
    GrammarFeature: React.lazy(() => import('../components/exercises/GrammarFeature')),
    ClozeExercise: React.lazy(() => import('../components/exercises/ClozeExercise')),
    VocabularyLearn: React.lazy(() => import('../components/learning/VocabularyLearn')),
    GrammarLearn: React.lazy(() => import('../components/learning/GrammarLearn')),
    ChapterCompletion: React.lazy(() => import('../components/navigation/ChapterCompletion')),
    ChapterReview: React.lazy(() => import('../components/navigation/ChapterReview')),
    ReviewGenerator: React.lazy(() => import('../components/learning/ReviewGenerator')),
    TestVocabPractice: React.lazy(() => import('../components/dev/TestVocabPractice')),
    TeachModule: React.lazy(() => import('../components/TeachModule/TeachModule')),
    VocabTeachModule: React.lazy(() => import('../components/TeachModule/VocabTeachModule')),
    AdvertTeachModule: React.lazy(() => import('../components/TeachModule/AdvertTeachModule')),
    ComicReader: React.lazy(() => import('../components/ComicReader/ComicReader')),
    ShapePuzzle: React.lazy(() => import('../components/deprecated/ShapePuzzleNew')),
    ShapePuzzleNew: React.lazy(() => import('../components/deprecated/ShapePuzzleNew')),
    VideoCutscenePlayer: React.lazy(() => import('../components/learning/VideoCutscenePlayer')),
};

// Log registered components at startup
console.log('📦 Static Component Registry initialized with:', Object.keys(StaticComponentRegistry));

// Use static registry instead of dynamic loading
const registry = StaticComponentRegistry;

// Helper: get lazy component by name (from Firestore moduleMap.component)
export const getComponentFromRegistry = (name) => {
    console.group('🔍 getComponentFromRegistry: Looking up component');
    console.log('Component name requested:', name);
    console.log('Available lazy components:', Object.keys(registry));

    if (!name) {
        console.error('❌ No component name provided');
        console.groupEnd();
        return null;
    }

    // Redirect deprecated DialogueFeature to DialogueUniversal
    if (name === 'DialogueFeature') {
        console.warn('⚠️ Redirecting deprecated DialogueFeature to DialogueUniversal');
        name = 'DialogueUniversal';
    }

    // Redirect deprecated VocabularyFeature (debug stub) to VocabularyLearn
    if (name === 'VocabularyFeature') {
        console.warn('⚠️ Redirecting deprecated VocabularyFeature to VocabularyLearn');
        name = 'VocabularyLearn';
    }

    const Component = registry[name];

    if (!Component) {
        // Try case-insensitive match
        const lowerName = name.toLowerCase();
        const match = Object.keys(registry).find(k => k.toLowerCase() === lowerName);
        if (match) {
            console.log(`⚠️ Case mismatch found: requested "${name}", using "${match}"`);
            console.groupEnd();
            return registry[match];
        }

        console.error(`❌ Component "${name}" not found in registry`);
        console.groupEnd();
        return null;
    }

    console.log(`✅ Component "${name}" found`);
    console.groupEnd();
    return Component;
};

// Export raw registry if needed
export const componentRegistry = registry;
